import { Table } from '@tanstack/react-table';
import { TableFilter } from './filter';
import { TableRoofChipList } from '../../compound/tables/presentation/table/roofs/shared/chipList';
import { TableRoofFilter } from '../../compound/tables/presentation/table/roofs/shared/filter';
import { DataTableResults } from './results';
import { DataTableSearch } from './search';

type Props<T> = {
  table: Table<T>;
  /** i18n key counted against the row total, e.g. `pxtraCard:person`. */
  headline: string;
  /** Tables with row selection drop it when the rows underneath change. */
  resetsSelection?: boolean;
};

/**
 * `TableToolBar` names rows generically and sizes its chip list for the
 * employee tables; this one is told what its rows are called.
 */
export const HeadlineToolBar = <T,>({ table, headline, resetsSelection = false }: Props<T>) => (
  <div className="flex items-center min-h-12 justify-between gap-3 py-3 min-w-0">
    <DataTableResults customHeadline={headline} table={table} />
    <TableRoofChipList
      chips={table.getState().columnFilters.map((filter) => {
        const column = table.getColumn(filter.id);
        const filterOptions = column?.columnDef.meta?.filterOptions;
        const option = filterOptions?.find((opt) => String(opt.value) === String(filter.value));

        return {
          label: option ? option.text : String(filter.value),
          value: filter.id,
          onDelete: () => {
            table.getColumn(filter.id)?.setFilterValue(undefined);

            if (resetsSelection) table.resetRowSelection();
          }
        };
      })}
      justify="flex-start"
      sx={{ flex: 1, minWidth: 0 }}
    />
    <DataTableSearch table={table} />
    <TableRoofFilter renderFilter={() => <TableFilter table={table} />} />
  </div>
);
